export const X_CARE_BASIC_AND_CONSUME_2022 = 'X_CARE_BASIC_AND_CONSUME_2022' // 极加服务22版
export const X_CARE_EXTEND_2022 = 'X_CARE_EXTEND_2022' // 极加服务22版
export const X_CARE_RENEW_2022 = 'X_CARE_RENEW_2022' // 极加服务22版
export const X_CARE_2022_V1 = 'X_CARE_2022_V1' // 极加服务22版
export const NO_DEDUCTIBLE_ACT_2022 = 'NO_DEDUCTIBLE_ACT_2022' // 不计免赔
export const NO_DEDUCTIBLE_SALE_2022 = 'NO_DEDUCTIBLE_SALE_2022' // 不计免赔
export const X_CARE_PINGAN_2023_BASIC = 'X_CARE_PINGAN_2023_BASIC' // 安心保基础版
export const X_CARE_PINGAN_2023_ADVANCE = 'X_CARE_PINGAN_2023_ADVANCE' // 安心保进阶版
export const NO = 'NO' //付费服务
export const QUALITY = 'QUALITY' // 质保服务
export const AUTH_WAREHOUSE = 'AUTH_WAREHOUSE' // 授权维修网点
export const OWN_WAREHOUSE = 'OWN_WAREHOUSE' // 直营网点
export const isValueAddService = (type: string): boolean => {
  // 是否为增值服务
  const arr = [
    X_CARE_BASIC_AND_CONSUME_2022,
    X_CARE_EXTEND_2022,
    NO_DEDUCTIBLE_ACT_2022,
    NO_DEDUCTIBLE_SALE_2022,
    X_CARE_PINGAN_2023_BASIC,
    X_CARE_PINGAN_2023_ADVANCE,
  ]
  return arr.indexOf(type) !== -1
}
// 服务单状态：WAIT_RECEIVE:待接收  HANDLE_ING:维修中 END:已完成 CANCEL:已取消
export const ServiceOrderStatusColorMap = new Map([
  ['WAIT_RECEIVE', '#F7981C'],
  ['HANDLE_ING', '#F7981C'],
  ['END', '#00C378'],
  ['CANCEL', 'rgba(0, 0, 0, 0.44)'],
])

// 维修单-状态颜色 /绿1 蓝 2 黄 3 灰 4 红 5
export const RepairOrderStatusColorMap = new Map([
  ['1', '#00C378'],
  ['2', '#1991EB'],
  ['3', '#F7981C'],
  ['16', 'rgba(0, 0, 0, 0.44)'],
  ['4', 'rgba(0, 0, 0, 0.44)'],
  ['5', '#F85359'],
])
// 维修单 状态背景色 /绿1 蓝 2 黄 3 灰 4 红 5
export const RepairOrderStatusBackgroundColorMap = new Map([
  ['1', 'rgba(0, 195, 120, 0.1)'],
  ['2', 'rgba(25, 145, 235, 0.1)'],
  ['3', 'rgba(247, 152, 28, 0.1)'],
  ['4', 'rgba(0, 0, 0, 0.04)'],
  ['5', 'rgba(248, 83, 89, 0.1)'],
])
// 是否为安心保订单
export const judgeIsFuselageInsurance = function (type: string): boolean {
  return type === X_CARE_PINGAN_2023_BASIC || type === X_CARE_PINGAN_2023_ADVANCE
}
// 是否质保在保
export const judgeIsQualityIn = function (value: number): boolean {
  return value === 1
}
// 是否为授权网点
export const isAuthWarehouse = function (value: string): boolean {
  return value === AUTH_WAREHOUSE
}

// 服务费用单收费规则
export const ServiceChargeRuleMap = new Map([
  [1, '按总价收费'],
  [2, '固定单据收费'],
  [3, '阶梯规则收费'],
])

// 服务费用单状态颜色
export const ServiceChargeStatusColorMap = new Map([
  ['WAIT_PAY', '#F7981C'],
  ['PAID', '#00C378'],
  ['CANCEL', 'rgba(0, 0, 0, 0.44)'],
])

// 支付成功文案
export const PaySussessTexMap = new Map([
  ['serviceCharge', '服务费用单'],
  ['', '维修单'],
  ['upgradeMainTenance', '维修单'],
  ['technicalSupport', '付费技术支持订单'],
])

// 升级保养单状态颜色
export const UpdateMaintenanceStatusColorMap = new Map([
  ['2', '#F7981C'],
  ['3', '#F7981C'],
  ['4', '#F7981C'],
  ['4-1', '#F7981C'],
  ['4-2', '#F7981C'],
  ['5', '#F7981C'],
  ['11', '#F7981C'],
  ['13', '#39B54A'],
  ['14', '#000000'],
])
